module.exports = __webpack_public_path__ + "static/media/flask1-background.c5cf91d6.png";